import React from "react";
import { Card, CardContent, Typography, Box, Grid, Button } from "@mui/material";
import "./bullying.css";

const Bullying = ({ nextStep, prevStep }) => {
  return (
    <Box className='bullying-container-form'>
      <Box className='right-flower-character' mr={-4}>
        <img src='./CYPImages/WormisFlower.png' alt='right-flower character' className='right-flower-character-image' />
      </Box>
      <Card className='bullying-card'>
        <CardContent>
          {/* Bullying Title */}
          <Typography variant='h4' className='bullying-title' align='center' gutterBottom>
            Bullying
          </Typography>

          {/* First Section */}
          <Grid container spacing={3} alignItems='center' justifyContent='center'>
            <Grid item xs={12} sm={6} className='text-section'>
              <Box className='speech-bubble-left' mt={4}>
                <Typography>
                  At Little Norway, we don’t tolerate bullying. Here’s what to do if you or someone you know is being
                  bullied.
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Box ml={2}>
                <img src='./CYPImages/bullytopright.png' alt=' character' className='bully' />
              </Box>
              <Box className='speech-bubble-right'>
                <Typography>
                  Bullying can be physical, verbal, or online. It includes hitting, insults, exclusion, or
                  cyberbullying.
                </Typography>
              </Box>
            </Grid>
          </Grid>

          {/* Image Section */}
          <Box>
            {/* First two images in a single line without space */}
            <Grid container mt={-13}>
              <Grid item xs={4} sm={4}>
                <img src='./CYPImages/left.png' alt='Bullying illustration' className='bullying-image' />
              </Grid>

              <Grid item xs={4} sm={4}>
                <img src='./CYPImages/right.png' alt='Bullying illustration' className='bullying-image' />
              </Grid>
            </Grid>

            {/* Third image below the first two */}
            <Grid container ml={10} mt={-23} sx={{ position: "relative", zIndex: 2 }}>
              <Grid item xs={4} sm={4}>
                <img src='./CYPImages/bottom.png' alt='Bullying illustration' className='bullying-image' />
              </Grid>
            </Grid>
          </Box>

          {/* Second Section */}
          <Grid container spacing={2} alignItems='center' justifyContent='center' mt={-15}>
            <Grid item xs={12} sm={12}>
              <Box ml={10} sx={{ position: "relative", zIndex: 10 }}>
                <img src='./CYPImages/bullycenter.png' alt=' character' className='bully' />
              </Box>
              <Box className='speech-bubble-center'>
                <Typography>
                  If you're being bullied, tell an adult like a teacher, caregiver, or social worker, or call the
                  numbers listed in this booklet.
                </Typography>
              </Box>
            </Grid>
          </Grid>

          {/* Remember Section */}
          <Box className='remember-section'>
            <Typography variant='h6' align='center' color='error'>
              REMEMBER!
            </Typography>
            <Typography align='center'>
              Always tell someone if you're being bullied. Ignoring it lets bullies continue. You have the right to be
              safe. Little Norway has an anti-bullying policy, and all reports will be handled quickly.
            </Typography>
          </Box>
        </CardContent>
        <Grid container justifyContent='space-between' alignItems='center' mt={2}>
          <Grid item>
            <Button type='button' variant='contained' color='primary' onClick={prevStep}>
              Previous
            </Button>
          </Grid>
          <Grid item>
            <Button type='button' variant='contained' color='primary' onClick={nextStep}>
              Next
            </Button>
          </Grid>
        </Grid>
      </Card>

      <Box className='bottom-education' mr={3}>
        <img src='./CYPImages/WormisStayingHome.png' alt='Bottom Character' className='bottom-education-image' />
      </Box>
    </Box>
  );
};

export default Bullying;
